import React from 'react';

import * as styles from './ImageLabel.styles';

const IconCrown = () => (
  <svg fill="none" height="9" viewBox="0 0 10 9" width="10" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M1.5 9V8H8.5V9H1.5ZM1.5 7.25L0.8625 3.2375C0.845833 3.2375 0.827083 3.23958 0.80625 3.24375C0.785417 3.24792 0.766667 3.25 0.75 3.25C0.541667 3.25 0.364583 3.17708 0.21875 3.03125C0.0729167 2.88542 0 2.70833 0 2.5C0 2.29167 0.0729167 2.11458 0.21875 1.96875C0.364583 1.82292 0.541667 1.75 0.75 1.75C0.958333 1.75 1.13542 1.82292 1.28125 1.96875C1.42708 2.11458 1.5 2.29167 1.5 2.5C1.5 2.55833 1.49375 2.6125 1.48125 2.6625C1.46875 2.7125 1.45417 2.75833 1.4375 2.8L3 3.5L4.5625 1.3625C4.47083 1.29583 4.39583 1.20833 4.3375 1.1C4.27917 0.991667 4.25 0.875 4.25 0.75C4.25 0.541667 4.32292 0.364583 4.46875 0.21875C4.61458 0.0729167 4.79167 0 5 0C5.20833 0 5.38542 0.0729167 5.53125 0.21875C5.67708 0.364583 5.75 0.541667 5.75 0.75C5.75 0.875 5.72083 0.991667 5.6625 1.1C5.60417 1.20833 5.52917 1.29583 5.4375 1.3625L7 3.5L8.5625 2.8C8.54583 2.75833 8.53125 2.7125 8.51875 2.6625C8.50625 2.6125 8.5 2.55833 8.5 2.5C8.5 2.29167 8.57292 2.11458 8.71875 1.96875C8.86458 1.82292 9.04167 1.75 9.25 1.75C9.45833 1.75 9.63542 1.82292 9.78125 1.96875C9.92708 2.11458 10 2.29167 10 2.5C10 2.70833 9.92708 2.88542 9.78125 3.03125C9.63542 3.17708 9.45833 3.25 9.25 3.25C9.23333 3.25 9.21458 3.24792 9.19375 3.24375C9.17292 3.23958 9.15417 3.2375 9.1375 3.2375L8.5 7.25H1.5ZM2.35 6.25H7.65L7.975 4.1625L6.6625 4.7375L5 2.45L3.3375 4.7375L2.025 4.1625L2.35 6.25Z"
      fill="#7066E0"
    />
  </svg>
);

const IconDiamond = () => (
  <svg fill="none" height="9" viewBox="0 0 10 9" width="10" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M5 9L0 3L1.5 0H8.5L10 3L5 9ZM3.8125 2.5H6.1875L5.4375 1H4.5625L3.8125 2.5ZM4.5 6.8375V3.5H1.725L4.5 6.8375ZM5.5 6.8375L8.275 3.5H5.5V6.8375ZM7.3 2.5H8.625L7.875 1H6.55L7.3 2.5ZM1.375 2.5H2.7L3.45 1H2.125L1.375 2.5Z"
      fill="#7066E0"
    />
  </svg>
);

export enum IconType {
  Crown = 'crown',
  Diamond = 'diamond',
}

export enum ImageLabelColor {
  Grey = 'grey',
  Purple = 'purple',
  Red = 'red',
}

export interface ImageLabelProps {
  color: ImageLabelColor;
  icon?: IconType;
  text: string;
}

const colorStyleMap = {
  [ImageLabelColor.Red]: styles.red,
  [ImageLabelColor.Grey]: styles.grey,
  [ImageLabelColor.Purple]: styles.purple,
};

const iconComponentMap = {
  [IconType.Crown]: IconCrown,
  [IconType.Diamond]: IconDiamond,
};

export const ImageLabel = ({ color, icon, text }: ImageLabelProps) => {
  const Icon = icon ? iconComponentMap[icon] : null;

  return (
    <div css={[styles.root, colorStyleMap[color]]}>
      {Icon && <Icon />}
      {text}
    </div>
  );
};
